"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypedValue = void 0;
const react_1 = __importDefault(require("react"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const TypedValue_styles_1 = require("./TypedValue.styles");
const TypedValue = ({ subRow, description, enableToolTip, type, value, toolTipKey, enableToolTipCustom, enableToolTipCustomId, perValue, perValueType, }) => {
    const isTouchDevice = () => {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    };
    const dataEvent = isTouchDevice() ? "click focus" : "";
    const typedValueType = subRow
        ? "subRow"
        : description
            ? "description"
            : enableToolTip
                ? "toolTip"
                : enableToolTipCustom
                    ? "toolTipCustom"
                    : "normal";
    switch (typedValueType) {
        case "description":
            return (react_1.default.createElement(TypedValue_styles_1.MessageWrapper, { "data-tip": toolTipKey, "data-for": toolTipKey, "data-delay-hide": 100, "data-effect": "solid" },
                react_1.default.createElement(TypedValue_styles_1.Abbreviation, null,
                    react_1.default.createElement(TypedValue_styles_1.Value, null, value),
                    react_1.default.createElement(TypedValue_styles_1.Type, null, type)),
                react_1.default.createElement(react_tooltip_1.default, { id: toolTipKey, place: "bottom" })));
        case "toolTip":
            return (react_1.default.createElement(TypedValue_styles_1.Abbreviation, { "data-tip": toolTipKey, "data-event": dataEvent },
                react_1.default.createElement(TypedValue_styles_1.Value, null, value),
                react_1.default.createElement(TypedValue_styles_1.Type, null, type)));
        case "toolTipCustom":
            return (react_1.default.createElement(TypedValue_styles_1.Abbreviation, { "data-tip": true, "data-for": enableToolTipCustomId, "data-event": dataEvent },
                react_1.default.createElement(TypedValue_styles_1.Value, null, value),
                react_1.default.createElement(TypedValue_styles_1.Type, null, type)));
        case "subRow":
            return (react_1.default.createElement(TypedValue_styles_1.RowWrapper, null,
                react_1.default.createElement(TypedValue_styles_1.Row, null,
                    react_1.default.createElement(TypedValue_styles_1.RowValue, null, perValue),
                    react_1.default.createElement(TypedValue_styles_1.RowType, null, perValueType)),
                react_1.default.createElement(TypedValue_styles_1.Row, null,
                    react_1.default.createElement(TypedValue_styles_1.RowSubValue, null, value),
                    react_1.default.createElement(TypedValue_styles_1.RowSubType, null, type))));
        case "normal":
        default:
            return (react_1.default.createElement(TypedValue_styles_1.Wrapper, null,
                react_1.default.createElement(TypedValue_styles_1.Value, null, value),
                react_1.default.createElement(TypedValue_styles_1.Type, null, type)));
    }
};
exports.TypedValue = TypedValue;
//# sourceMappingURL=TypedValue.js.map